import { nameInput, tenDigits } from './helpers';

// "Others in the family", typed as plain names on one line.
//
// The event's own data is why this is a text box and not four more rows: 95 of
// 100 family members simply repeat the head's surname and only half have a
// phone number at all. So a household is "Kamla, Ravi 9822011111; Priya" —
// names separated by commas, each with a number after it when that person has
// one.
//
// Pure, so the parsing is tested without a browser.
export function parseFamilyNames(text, surname) {
  return String(text || '')
    .split(/[,;]/)
    .map(v => v.trim())
    .filter(Boolean)
    .map(piece => {
      // A number at the END belongs to the name before it; digits inside a
      // name ("Ravi 2") are left alone.
      const m = piece.match(/(\d[\d\s-]{8,})$/);
      const mobile = m ? tenDigits(m[1]) : '';
      const name = nameInput(m ? piece.slice(0, m.index).trim() : piece);
      return {
        GuestName: name,
        Surname: String(surname || '').trim() || null,
        MobileNumber: /^\d{10}$/.test(mobile) ? mobile : null,
      };
    })
    .filter(m => m.GuestName);
}
